angular.module('lsnBase.deprecated.models')
  .factory('ApplicationModelConstants', ['LsnApplicationModelConstants', function(LsnApplicationModelConstants) {
    return LsnApplicationModelConstants;
  }])
  .factory('ApplicationModel', ['LsnApplicationModelV1',
    function(LsnApplicationModelV1) {
      return LsnApplicationModelV1;
    }
  ]);